import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom} from '@mui/material';
import {DispatchContext} from '../../../store';
import {useNavigate} from 'react-router';
import {taskPoolServices} from '../../../services/TaskPoolServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import Box from '@mui/material/Box';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});
export default function RejectTransfer(props) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const {open, handleAction, roleId, taskPool} = props;
  const poolId = taskPool?.map(value => value?.role_id);

  const isRoleIdInPool = poolId.includes(roleId);

  let taskPoolId = null;

  if (isRoleIdInPool) {
    const index = poolId.indexOf(roleId);

    if (index !== -1) {
      taskPoolId = taskPool[index]?.id;
    }
  }

  const onSubmit = (values) => {
    taskPoolServices('put', taskPoolId, {...values}).then(res => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Catalogue transfer rejected successfully'}
      });
      navigate('/management/loan');
      handleAction();
    })
  }
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle color={'#616B88'} sx={{fontSize: 30}} className={'text-bold'}
                   fontWeight={700}>Rejection reason</DialogTitle>
      <Box className={'common-divider'}/>
      <Formik initialValues={{action: 'reject', remarks: ''}}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            <DialogContent sx={{width: 300}}>
              <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Reason for rejection'}
                     name="remarks" multiline rows={5}
                     InputLabelProps={{
                       style: {fontSize: 14, color: '#929191'}
                     }}/>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAction} variant={'outlined'}
                      color={'error'} className={'text-capitalize'}>
                Cancel
              </Button>
              <Button variant={'contained'} type={'submit'} className={'text-capitalize'}>Confirm</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}